import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AbstractDynamicForm, FormControlWrapper } from '../../../dynamic-form-abstract';

@Component({
	selector: 'app-dynamic-form-input-drop-down',
	standalone: false,
	templateUrl: './dynamic-form-input-drop-down.component.html',
	styleUrl: './dynamic-form-input-drop-down.component.scss'
})
export class DynamicFormInputDropDownComponent {
	@Input() wrapper!: FormControlWrapper;
	@Input() form!: FormGroup;
	@Input() inline: boolean = false;
	@Input() readonly = false;
	toControlKey = AbstractDynamicForm.toControlKey;

}
